var _Array$isArray = require("@babel/runtime-corejs3/core-js/array/is-array");

function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;


// WEBPACK FOOTER //
// webpack://idx/node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js